<template>
    <div :class="`home main-con ${homeColor}`">
        <template v-if="showDesktop">
            <div class="main-con-wrapper">
                <div class="con-wrapper">
                    <main-header></main-header>
                    <div class="banner-wrapper row">
                        <div class="col-xs-12 col-sm-6">
                        </div>
                        <div class="col-xs-12 col-sm-6 rg-card-con">
                            <p-register-card ref="register-card"></p-register-card>
                        </div>
                    </div>
                </div>
            </div>
            <div class="profile-list-wrapper">
                <div class="con-wrapper row">
                    <div v-for="(profile, key) in profiles" :key="key" class="profile-con col-xs-12 col-sm-2">
                        <router-link :to="{ name: 'login' }" class="pic-con">
                            <img :src="profile.thumb_picture" class="profile-pic img-responsive">
                        </router-link>
                        <div class="profile-details">
                            <h3 class="nick-name">{{ profile.nick_name }}</h3>
                            <p class="age">{{ profile.age }} {{ 'yrs' | translate }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="find-members-wrapper">
                <div class="con-wrapper">
                    <h2 v-html="midSecTitle" />
                    <p v-html="midSecSlogan" />
                    <button class="btn btn-primary" @click="gotoTop">
                        <span v-html="midSecButton" />
                    </button>
                </div>
            </div>
            <div class="statements-wrapper">
                <div class="con-wrapper row">
                    <div class="col-xs-12 col-sm-6">
                        <h2 v-html="contentLeftTitle" />
                        <p v-html="contentLeftText" />
                        <a v-if="content.content_left_button_url && content.content_left_button_url != '#'" :href="content.content_left_button_url" v-html="contentLeftButton" />
                        <a v-else href="/" @click.stop.prevent="gotoTop" v-html="contentLeftButton" />
                    </div>
                    <div class="col-xs-12 col-sm-6">
                        <h2 v-html="contentRightTitle" />
                        <p v-html="contentRightText" />
                        <a v-if="content.content_right_button_url && content.content_right_button_url != '#'" :href="content.content_right_button_url" v-html="contentRightButton" />
                        <a v-else href="/" @click.stop.prevent="gotoTop" v-html="contentRightButton" />
                    </div>
                </div>
            </div>
            <main-footer></main-footer>
        </template>
        <template v-else>
            <div class="con-wrapper mobile">
                <div class="mobile-content-con">
                    <div class="logo-con">
                        <router-link :to="{ name: 'home' }">
                            <img class="img-responsive" :src="`${icdn_url}/desktop-logo.png`" :alt="`Logo ${site_name}`" v-cloak>
                        </router-link>
                    </div>
                    <div class="btn-con">
                        <button class="btn btn-register btn-colored" @click="toggleMobileRegister">
                            <span>{{ 'Join now' | translate | normalize }}</span>
                        </button>
                        <button class="btn btn-login" @click="$router.push({ name: 'login' })">
                            <span>{{ 'Login' | translate | normalize }}</span>
                        </button>
                    </div>
                </div>
                <p-register-card ref="register-card" :show-form="open_mobile_register">
                </p-register-card>
                <m-footer ref="m-footer" :style="{ bottom: `${m_footer_height}px`}"></m-footer>
            </div>
        </template>
        <cookies-notice></cookies-notice>
    </div>
</template>

<script>
import MainHeader from '@views/common/MainHeader'
import MainFooter from '@views/common/MainFooter'
import MFooter from '@views/common/mobile/MFooter'
import PRegisterCard from '@views/public/partials/PRegisterCard'
import CookiesNotice from '@views/common/CookiesNotice'
import Home from '@views/public/pages/Home/home'

export default {
    mixins: [Home],
    components: {
        MainHeader,
        MainFooter,
        PRegisterCard,
        CookiesNotice,
        MFooter
    }
}

</script>

<style lang="scss" src="./home.scss"></style>
